import CallerNumberIsDisplay from './CallerNumberIsDisplay'
import CallerNumberIsForm from './CallerNumberIsForm.container'
import IconTick from 'components/Icons/Tick'
import IconClose from 'components/Icons/Close'
import IconPhoneLog from 'components/Icons/PhoneLog'

export default {
  id: 'caller_number_is',
  label: "Caller's number is",
  helpUrl: 'https://help.thinkpickle.com.au/flows/conditions/callers-number-is',
  icon: IconPhoneLog,
  inputs: [{}],
  outputs: [
    {
      name: 'false',
      label: 'False',
      icon: IconClose,
    },
    {
      name: 'true',
      label: 'True',
      icon: IconTick,
    },
  ],
  display: CallerNumberIsDisplay,
  form: CallerNumberIsForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/CallerNumberIs/index.js